var map = {
	"./components/applications/api/applications.mock.js": "423c",
	"./components/messages/api/messages.mock.js": "538b",
	"./components/orders/api/orders.mock.js": "04af",
	"./components/sidebar/api/sidebar.mock.js": "bfd3",
	"./components/templates/api/templates.mock.js": "b136",
	"./components/users/api/users.mock.js": "e741"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "3bd3";